import css from '../../../utils/css';

const contractTheme: string = css`
  :host,
  #root > div {
    --mix-of-text-and-background: color-mix(
      in lch,
      var(--widget-background-color) 90%,
      var(--widget-text-color)
    );
    --mix-of-text-and-background-2: color-mix(
      in lch,
      var(--widget-background-color) 80%,
      var(--widget-text-color)
    );
    --mix-of-accent-colors: color-mix(
      in lch,
      var(--widget-accent-background-color) 80%,
      var(--widget-accent-text-color)
    );
    --mix-of-accent-colors-2: color-mix(
      in lch,
      var(--widget-accent-text-color) 80%,
      var(--widget-accent-background-color)
    );
    --muted-text-color: color-mix(
      in lch,
      var(--widget-text-color) 60%,
      transparent
    );
    --muted-accent-text-color: color-mix(
      in lch,
      var(--widget-accent-text-color) 60%,
      transparent
    );
    --special-mix: color: color-mix(
        in lch,
        var(--widget-cta-background-color) 50%,
        var(--widget-accent-text-color)
      );

    --widget-cta-text-color: var(--widget-text-color);
    --widget-cta-border-color: var(--widget-cta-hover-color);
    --widget-cta-primary-color: var(--widget-cta-hover-color);
    --widget-cta-primary-color-contrast: var(--widget-cta-color);
    --widget-form-selected-background-color: var(--mix-of-accent-colors);
    --widget-form-selected-border-color: var(--mix-of-accent-colors-2);
    --widget-child-background-color: var(--mix-of-text-and-background);
    --widget-child-text-color: var(--widget-text-color);
    --widget-modal-background-color: #001e28;
    --widget-modal-background-color-contrast: white;
    --widget-modal-border-radius-custom: var(--widget-border-radius, 4px);
    --cxy-border-radius-l: var(--widget-border-radius, 8px);
    --cxy-border-radius-s: var(--widget-inner-border-radius, 4px);
    --cxy-border-radius-xs: var(--widget-inner-border-radius, 4px);
    --widget-modal-buttons-border-radius-custom: var(
      --widget-cta-border-radius,
      4px
    );
    --cxy-color-content-default: var(--widget-accent-text-color);
    --cxy-color-border-subtle: var(--widget-accent-background-color);
    --cxy-color-interactive-senary-inverse: var(--widget-cta-color);
    --cxy-color-container-error: var(--widget-accent-background-color);
    --cxy-color-error: var(--widget-accent-text-color);
    --cxy-font-family-sans: var(--widget-font-family);

    [data-testid='subevent-dropdown'] {
      white-space: nowrap;
      min-width: 120px;
      width: auto;
    }

    [class*='_bookieSelectorWrapper_'] > button > span {
      color: var(--widget-text-color);
    }

    button[class*='_button_'],
    [class*='_eventRow_'],
    button[data-testid='subevent-dropdown'] {
      --cxy-border-radius-s: var(--widget-cta-inner-border-radius, 4px);
    }

    [class*='_bookieListItem_']:not([class*='_isActive_']) {
      color: var(--widget-accent-text-color);
    }

    [class*='_priceItem_'] {
      border-radius: var(--widget-cta-border-radius, 4px);
    }

    [class*='_addMarketSelect_'] [class*='_listBody_'] {
      border-radius: var(--widget-inner-border-radius, 3px);
    }

    /*--cxy-color-content-feature*/
    [class*='_clickOutWrapper_'] {
      color: var(--widget-cta-color);
      fill: currentColor;
      border-radius: var(--widget-cta-border-radius, 4px);
    }

    [class*='_eventRow_'] {
      font-family: inherit;
      overflow: clip;
      background-color: var(--widget-accent-background-color);

      button[class*='_eventWrapper_'] {
        color: var(--widget-accent-text-color);
        background-color: inherit;
      }
    }

    --widget-brand-logo: none;
    [class*='_externalBrandLogo_'] {
      text-align: center;

      &::before {
        content: 'Bet Builder';
        text-transform: uppercase;
        display: inline-block;
        margin: auto;
        font-family: var(--widget-font-family);
        font-size: 24px;
        font-weight: 700;
        letter-spacing: -1px;
        color: var(--widget-text-color);
      }
    }

    /* menu refinement */
    [class*='_listLinePickerBody_'],
    [class*='_listPickerBody_'] {
      & + button,
      button {
        color: var(--widget-accent-text-color);
      }

      [class*='_bestOdds_'] {
        color: var(--special-mix);
      }
    }
    [class*='_subeventPickerListDate_'] {
      color: var(--muted-accent-text-color);
    }
    [class*='_hasTrailingIcon_'] svg path {
      fill: currentColor;
    }

    /* pre populated text and details */
    [class*='_betLegsItem_'][class*='_prePopulated_'] {
      color: var(--widget-text-color);
    }
    [class*='_bulletLine_'][class*='_prePopulated_'],
    [class*='_bulletCircleOuter_'] {
      background-color: var(--widget-text-color);
    }
    [class*='_prePopulatedDateTime_'] {
      color: var(--muted-text-color);
    }

    /* hover for markets */
    [class*='_market_']:hover {
      background: var(--mix-of-accent-colors);
    }

    /* new tag */
    [class*='_newTag_'] {
      color: var(--widget-cta-color);
    }

    /* main cta text color */
    :not([class*='prePopulated_']) [data-testid='compare-odds'] {
      color: var(--widget-cta-color);
    }

    /* not visible on white bg */
    [data-testid='offers-modal-trigger'],
    [class*='prePopulated_'] [data-testid='compare-odds'] {
      color: var(--widget-text-color);
    }

    /* for fun */
    li[class*='_row_']:not(:last-child) {
      border-color: var(--widget-divider-color);
    }

    /* disclaimer text color */
    [data-testId='bet-builder-disclaimer'],
    [data-testId='bet-builder-disclaimer'] * {
      color: var(--muted-text-color);
    }
  }
`;

export default contractTheme;
